/* istanbul ignore next */
const ACTIONS = {
    GET_REVIEW_METADATA: 'GET_REVIEW_METADATA',
    TOGGLE_EDIT_MODAL: 'TOGGLE_EDIT_MODAL',
    GET_REVIEW_METADATA_SUCCESS: 'GET_REVIEW_METADATA_SUCCESS',
    REVIEW_PAGE_SERVICE_ERROR: 'REVIEW_PAGE_SERVICE_ERROR',
    SET_FIELD: 'SET_FIELD',
    SET_FIELD_ERROR: 'SET_FIELD_ERROR',
    EDIT_MODAL_SERVICE_ERROR: 'EDIT_MODAL_SERVICE_ERROR',
    UPDATE_SERVICE_SUCCESS: 'UPDATE_SERVICE_SUCCESS',
    UPDATE_ACCOUNT_DETAILS: 'UPDATE_ACCOUNT_DETAILS',
    TOGGLE_REVIEW_MODAL_SAVE_BUTTON: 'TOGGLE_REVIEW_MODAL_SAVE_BUTTON',
    SET_REVIEW_MODAL_ADDRESS_CHOICE: 'SET_REVIEW_MODAL_ADDRESS_CHOICE',
    TOGGLE_REVIEW_VAT_EDIT_BUTTON: 'TOGGLE_REVIEW_VAT_EDIT_BUTTON'
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    getReviewMetadata() {
        return {
            type: ACTIONS.GET_REVIEW_METADATA
        };
    },

    toggleEditModal(modalType, fieldVal, defaultLocale) {
        return {
            type: ACTIONS.TOGGLE_EDIT_MODAL,
            payload: {
                modalType,
                fieldVal,
                defaultLocale
            }
        };
    },

    setField(fieldName, fieldValue) {
        return {
            type: ACTIONS.SET_FIELD,
            payload: {
                fieldName,
                fieldValue
            }
        };
    },

    setFieldError(fieldName, msg) {
        return {
            type: ACTIONS.SET_FIELD_ERROR,
            payload: {
                fieldName,
                msg
            }
        };
    },

    getReviewMetadataSuccess(reviewDetails, siteName) {
        return {
            type: ACTIONS.GET_REVIEW_METADATA_SUCCESS,
            payload: {
                reviewDetails,
                siteName
            }
        };
    },

    alertError(errorKey) {
        return {
            type: ACTIONS.REVIEW_PAGE_SERVICE_ERROR,
            payload: {
                errorKey
            }
        };
    },

    alertErrorForModal(errorKey) {
        return {
            type: ACTIONS.EDIT_MODAL_SERVICE_ERROR,
            payload: {
                errorKey
            }
        };
    },

    updateServiceSuccess() {
        return {
            type: ACTIONS.UPDATE_SERVICE_SUCCESS
        };
    },

    updateAccountDetails(accountDetails) {
        return {
            type: ACTIONS.UPDATE_ACCOUNT_DETAILS,
            payload: {
                accountDetails
            }
        };
    },

    toggleSaveButton() {
        return {
            type: ACTIONS.TOGGLE_REVIEW_MODAL_SAVE_BUTTON
        };
    },

    toggleVatEditButton() {
        return {
            type: ACTIONS.TOGGLE_REVIEW_VAT_EDIT_BUTTON
        };
    },

    setAddressChoice(fieldValue) {
        return {
            type: ACTIONS.SET_REVIEW_MODAL_ADDRESS_CHOICE,
            payload: {
                fieldValue
            }
        };
    }
};

export default {
    ...ACTIONS,
    ...ACTION_CREATORS
};
